export const locationTypePackages = [
  "Headquarters",
  "Branch",
]